<template>
    <div v-if="flight" class="flight-card-container mb-4">
      <v-card 
        class="flight-card rounded-xl overflow-hidden elevation-2"
        :ripple="false"
      >
        <div class="card-gradient-bar"></div>
  
        <v-card-text class="pa-5">
          <v-row align="center" justify="space-between" class="ma-0">
            
            <v-col cols="12" md="7" class="pa-0 mb-4 mb-md-0">
              <div class="d-flex align-center mb-3">
                <v-avatar color="teal lighten-5" size="50" class="mr-3">
                  <v-icon color="teal darken-2" dark>mdi-airplane-takeoff</v-icon>
                </v-avatar>
                <div>
                  <div >
                    <span class="text-subtitle-1 font-weight-black text-uppercase tracking-wide dark-blue--text">
                      {{ flight.carrier_name }} 
                    </span>
                    <span class="text-subtitle-4 dark-green--text"> [Flight: {{ flight.flight_number }}] </span>
                  </div>
                  <div class="caption blue--text text--darken-4 font-weight-medium">
                    Depature: {{ flight.departure_date }} Time: {{ flight.departure_time }}
                  </div>

                  <div class="caption green--text text--darken-4 font-weight-medium">
                    Arrival: {{ flight.arrival_date }} Time: {{ flight.arrival_time }}
                  </div>
                </div>
              </div>
  
              <div class="d-flex align-center mt-4 route-display">
                <div class="airport-code">
                  <span class="display-1 font-weight-black primary-code">{{ searchParams.origin }}</span>
                  <span class="caption d-block grey--text text--darken-1">{{ getAirportCity(searchParams.origin) }}</span>
                </div>
                
                <div class="flex-grow-1 mx-4 position-relative d-flex align-center justify-center flight-path-line">
                  <v-icon class="moving-plane-icon" color="teal">mdi-airplane</v-icon>
                </div>
  
                <div class="airport-code text-right">
                  <span class="display-1 font-weight-black primary-code">{{ searchParams.destination }}</span>
                  <span class="caption d-block grey--text text--darken-1">{{ getAirportCity(searchParams.destination) }}</span>
                </div>
              </div>
            </v-col>

            </v-row>

            <v-row>
              <v-col :cols="6">
                <div>
                  <div>
                  <div >
                    
                    <span class="text-subtitle-1 font-weight-black text-uppercase tracking-wide dark-blue--text">
                      {{ searchParams.cabin_class }} 
                    </span>
                    
                  </div>
                  <div class="caption blue--text text--darken-4 font-weight-medium">
                    Children: {{ searchParams.children }}
                  </div>

                  <div class="caption green--text text--darken-4 font-weight-medium">
                    Infants: {{ searchParams.infants }}
                  </div>
                </div>
                </div>
              </v-col>
            <v-col :cols="5" class="pa-0 text-md-right d-flex flex-column justify-center align-md-end">
              <div class="price-container mb-2">
                <span class="currency-symbol font-weight-bold teal--text">R</span>
                <span class="price-amount font-weight-black">{{ formatPrice(flight.price) }}</span>
              </div>
              <div class="caption font-weight-medium grey--text text--darken-1 mb-4">
                {{ "Transit" + returnS(flight.stop_counts) }}: <v-chip x-small color="teal lighten-5" text-color="teal" class="font-weight-bold ml-1">
                  {{ flight.stop_counts < 1 ? "No Transit" : flight.stop_counts +" Layover" + returnS(flight.stop_counts) }}
                </v-chip>
              </div>
  
              <v-btn 
              v-if="!isMobile"
                block
                color="teal" 
                dark 
                large
                class="book-btn rounded-xl font-weight-bold elevation-0 py-6" 
                @click="openBookingGate"
              >
                <span>Book Flight</span>
                <v-icon right class="ml-2 btn-arrow">mdi-arrow-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-btn 
              v-if="isMobile"
                block
                color="teal" 
                dark 
                large
                class="book-btn rounded-xl font-weight-bold elevation-0 py-6" 
                @click="openBookingGate"
              >
                <span>Book Flight</span>
                <v-icon right class="ml-2 btn-arrow">mdi-arrow-right</v-icon>
              </v-btn>
        </v-card-text>
  
        <div class="card-footer-strip px-5 py-2 d-flex align-center">
          <v-icon small color="teal lighten-2">mdi-shield-check-outline</v-icon>
          <span class="caption grey--text text--darken-2 ml-2 font-weight-medium">
            Best price guaranteed • Cancellation options available
          </span>
        </div>
      </v-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FlightDataCard',
    props: {
      flight: {
        required: true,
        type: Object,
        default: () => null
      },
      searchParams: {
        required: true,
        type: Object,
        default: () => null
      },
    },
    computed:{
      getApiUrl(){
            return this.$store.getters.getApiUrl
        },
        isMobile(){
            return this.$store.getters.isMobile
        },
    },
    updated() {
    const isMobile = this.$vuetify.breakpoint.mobile;
    this.$store.commit("setIsMobile", isMobile);
  },
  mounted() {
    const isMobile = this.$vuetify.breakpoint.mobile;
    this.$store.commit("setIsMobile", isMobile);
  },
    methods: {
      returnS(count){
        if(Number(count) < 2) return ''
        return "s"
      },
      openBookingGate() {
        // Fixed minor bug: 'flight' needs to refer to 'this.flight' contextually
        this.$emit('open-booking-gate', this.flight);
      },
      formatPrice(amount) {
        if (!amount) return '0.00';
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      },
      getAirportCity(iataCode) {
        if (!iataCode) return "Johannesburg";
        const cities = {
        "BFN": "Bloemfontein",
        "CPT": "Cape Town",
        "DUR": "Durban",
        "ELS": "East London",
        "GRJ": "George",
        "HDS": "Hoedspruit",
        "JNB": "Johannesburg",
        "KIM": "Kimberley",
        "MQP": "Mbombela",
        "HLA": "Lanseria",
        "PLZ": "Gqeberha",
        "PTG": "Polokwane",
        "RCB": "Richards Bay",
        "SIS": "Sishen",
        "SZK": "Skukuza",
        "UTT": "Mthatha",
        "UPN": "Upington",
        "ACC": "Accra",
        "KMS": "Kumasi",
        "NYI": "Sunyani",
        "TML": "Tamale",
        "TKD": "Takoradi",
        "WST": "Wa"
};
          // Safe fallback: uses the mapped city, or returns the uppercase code if not found
          return cities[iataCode.toUpperCase()] || "";
        }
    }
  }
  </script>
  
  <style scoped>
  /* Container & Base Card Styling */
  .flight-card-container {
    perspective: 1000px;
  }
  
  .flight-card {
    position: relative;
    background: #ffffff;
    border: 1px solid rgba(0, 150, 136, 0.08);
    transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  /* Smooth hover lifting effect */
  .flight-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 150, 136, 0.12) !important;
    border-color: rgba(0, 150, 136, 0.2);
  }
  
  /* Request Item: Top Gradient Accent Bar */
  .card-gradient-bar {
    height: 6px;
    background: linear-gradient(90deg, #0c413c 0%, #4db6ac 50%, #00bfa5 100%);
    width: 100%;
  }
  
  /* Typography & Layout additions */
  .tracking-wide {
    letter-spacing: 0.5px !important;
  }
  
  .dark-blue--text {
    color: #1a237e;
  }
  
  .primary-code {
    color: #263238;
    letter-spacing: -1px;
  }
  
  /* Flight Path Line & Visualizer Components */
  .flight-path-line {
    height: 2px;
    background: repeating-linear-gradient(90deg, #b2dfdb, #b2dfdb 6px, transparent 6px, transparent 12px);
  }
  
  .moving-plane-icon {
    transform: rotate(90deg);
    background: #ffffff;
    padding: 0 8px;
    transition: transform 0.5s ease;
  }
  
  .flight-card:hover .moving-plane-icon {
    animation: glide 1.5s ease-in-out infinite;
  }
  
  /* Pricing Component Typography */
  .price-container {
    display: flex;
    align-items: baseline;
  }
  
  .currency-symbol {
    font-size: 1.25rem;
    margin-right: 2px;
  }
  
  .price-amount {
    font-size: 2.25rem;
    line-height: 1;
    color: #0c544b;
    letter-spacing: -1px;
  }
  
  /* Call To Action Button Styles */
  .book-btn {
    background: linear-gradient(135deg, #0b4f48 0%, #00796b 100%) !important;
    transition: all 0.3s ease !important;
    text-transform: none !important;
    letter-spacing: 0.5px;
  }
  
  .book-btn:hover {
    filter: brightness(1.1);
    box-shadow: 0 4px 12px rgba(0, 121, 107, 0.3) !important;
  }
  
  .btn-arrow {
    transition: transform 0.3s ease;
  }
  
  .book-btn:hover .btn-arrow {
    transform: translateX(4px);
  }
  
  /* Footer Accent Strip */
  .card-footer-strip {
    background-color: #fafafa;
    border-top: 1px solid #f0f0f0;
  }
  
  /* Keyframe Animations */
  @keyframes glide {
    0% { transform: rotate(90deg) translateX(-5px); }
    50% { transform: rotate(90deg) translateX(5px); }
    100% { transform: rotate(90deg) translateX(-5px); }
  }
  </style>